var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 870,
        visible: _vm.visible,
        footer: null,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "eval-preview" }, [
        _c(
          "div",
          { staticClass: "content" },
          _vm._l(_vm.dataSource, function (item, index) {
            return _c("div", { key: index }, [
              _c("div", { class: { topic: true } }, [
                _c("span", [_vm._v(_vm._s(item.name))]),
              ]),
              _c(
                "div",
                { staticClass: "select-area" },
                _vm._l(item.topicArr, function (optItem, optIndex) {
                  return _c(
                    "a-radio-group",
                    {
                      key: optIndex,
                      attrs: { disabled: true },
                      model: {
                        value: _vm.selectMode[index],
                        callback: function ($$v) {
                          _vm.$set(_vm.selectMode, index, $$v)
                        },
                        expression: "selectMode[index]",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: `${optItem.id}` } }, [
                        _c(
                          "span",
                          { staticStyle: { color: "rgba(0, 0, 0, 0.65)" } },
                          [_vm._v(_vm._s(optItem.name))]
                        ),
                      ]),
                    ],
                    1
                  )
                }),
                1
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }